import { ActionsType } from "src/interfaces/Common";
import { ActivityType } from "src/interfaces/Activities";

export type DecompressionIcon = "error" | "warning";

export function getActivityDecompressionIcon(
  row: any,
): DecompressionIcon | null {
  if (
    row?.type !== ActivityType.DA_SCORM &&
    row?.type !== ActivityType.DA_XAPI
  ) {
    return null;
  }
  const result = row?.unarchive_result;
  if (result === null || result === undefined) return null;
  const status = result?.status;
  if (status === "OK") return null;
  return status === "KO" ? "error" : "warning";
}

export function buildActivityDecompressionAction(
  row: any,
  i18nLang: string,
  options: {
    permission: string;
    onClick?: (id: any) => void;
  },
): ActionsType | null {
  const icon = getActivityDecompressionIcon(row);
  if (!icon) return null;
  return {
    key: "decompression",
    type: "decompression",
    permission: options.permission,
    label: { en: "Status", it: "Stato" },
    labelTranslate: i18nLang === "it" ? "Stato" : "Status",
    icon,
    callBack: options.onClick,
  } as unknown as ActionsType;
}
